<template>
  <div class="ppt-preview" id="pptPreviewId">
    <div class="ppt-error" v-if="pptError">
      <p>404！课件加载失败</p>
    </div>
    <div
      class="ppt-wrap"
      :class="{'h-420': pptSize === 'h-420'}"
      id="pptPreviewWrap"
      ref="pptPreviewWrap"
      v-show="!pptError"
      @mousewheel="handleScroll"
    >
      <pdf
        id="pptPreviewContent"
        class="pdf-content"
        :src="pdfUrl"
        :page="pageIndex + 1"
        :scale.sync="scale"
        :resize="true"
        @numpages="pageCount = $event"
      />
      <!-- @loading="_loading" -->

      <!-- 操作 -->
      <div class="pre-btn" :class="{'btn-dis': preDis}" @click.stop="_pageChange('left')">
        <i class="iconfont iconzuo-"></i>
      </div>
      <div class="next-btn" :class="{'btn-dis': nextDis}" @click.stop="_pageChange('right')">
        <i class="iconfont iconyou-"></i>
      </div>
      <!-- 缩略列表 -->
      <div
        class="pre-list-wrap"
        :class="{'up-down-change': !upDown}"
        v-if="!isFull"
        id="preListWrap"
      >
        <div class="up-down" @click="_upDown">
          <i class="iconfont" :class="upDown ? 'iconicon-test1' : 'iconicon-test'"></i>
        </div>
        <div class="current-page">{{pageIndex + 1}}/{{pageCount}}</div>
        <div class="mini-list-box">
          <div
            class="mini-pre-btn"
            :class="{'btn-dis': preDis}"
            @click.stop="_miniPageChange('left')"
          >
            <i class="iconfont iconzuo-"></i>
          </div>
          <div
            class="mini-next-btn"
            :class="{'btn-dis': nextDis}"
            @click.stop="_miniPageChange('right')"
          >
            <i class="iconfont iconyou-"></i>
          </div>
          <div class="mini-wrap-box" id="previewList">
            <div class="list-ul" id="pptListUl">
              <div
                class="list-li"
                :class="{'select-page': index === pageIndex}"
                v-for="(item, index) in thumbnails"
                :key="index"
                @click="_miniPageClick(index)"
              >
                <img :src="item" alt />
                <!-- <pdf
                  :src="pdfData"
                  :page="index+1"
                  class="pdf-thumbnail not-select"
                  :scale="0.1"
                  >
                </pdf>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- S 视频点击区域 -->
      <video-click-area
        v-if="item.i"
        v-for="(item, index) in videoInfos"
        :key="index"
        :videoInfo="item"
        :resolution="resolution"
        :otherParams="otherParams"
        @click.native="_areaButtonClick(item)"
      ></video-click-area>
      <!-- E 视频点击区域 -->
      <!-- S 视频 vs4 播放 -->
      <h5-video
        v-if="videoVisible && isFullBox === 'ppt'"
        ref="videoWrapper"
        :isTrailer="vs4Video.isTrailer"
        :trailerDuration="vs4Video.trailerDuration"
        :resourceId="vs4Video.resourceId"
        :videoUrl="vs4Video.videoUrl"
        :coverUrl="vs4Video.coverUrl"
        :enValue="vs4Video.enValue"
        :zhValue="vs4Video.zhValue"
        :enAndzhValue="vs4Video.enAndzhValue"
        :tValue="vs4Video.tValue"
        :fullscreenFlag="true"
        :hadLogo="vs4Video.hadLogo"
        :level="vs4Video.level"
        :subject="vs4Video.subject"
        @handleClose="_vs4Close"
      />
      <video-drag v-else-if="videoVisible" ref="videoDragRef" :videoInfo="vs4Video" @handleClose="_vs4Close" />
      <!-- E 视频 vs4 播放 -->
    </div>
  </div>
</template>

<script>
import Pdf from "pdfvuer";
import h5Video from "components/h5video";
import videoDrag from "components/h5video/video-drag";
import VideoClickArea from "./video-click-area";
import Cookies from "js-cookie";
import $ from "jquery";
import { SetVideoStatistics } from 'api/common';
import {
  enterFullScreen,
  exitFullScreen,
  isFullscreen,
  debounce
} from "utils/util";

export default {
  name: "pptPreview",
  components: {
    Pdf,
    h5Video,
    videoDrag,
    VideoClickArea
  },
  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    resolution: {
      type: String,
      // default: '16*9',
      default: "960*720"
      // default: '1280*720',
      // default: '964*776',
    },
    defaultSize: {
      type: Boolean,
      default: true
    },
    thumbnails: {
      type: Array,
      default: [],
      required: true
    },
    videos: {
      type: Object,
      default: () => {
        return {
          page6: [],
          page5: [],
          page4: [],
          page3: [],
          page2: [
            {
              a: "62安迪的动物宝宝+艺术+威德尔海豹+小海豹本领多_1.mp4",
              t: 285.425,
              w: 96.75,
              h: 96.75,
              i: "/show/2045/cw/F148AB29C472E31F3FF5180072A42171",
              l: 554.6249
            }
          ],
          page1: [],
          page7: []
        };
      }
    },
    fixedSize: {
      type: Boolean,
      default: false
    },
    boxId: {
      type: String,
      default: "pane-courseware"
    },
    resourceId: {
      type: [String, Number],
      required: false
    },
    level: { // level
      type: [Number, String],
      default: 2
    },
    subject: { // subject
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      pageIndex: 0,
      pageCount: 0,
      scale: "page-width",
      upDown: true, // true-->up, false-->down
      pageList: [],
      switching: false,
      isFull: false,
      imageW: this.defaultSize ? 143 : 110,
      // 视频信息
      videoInfo: {},
      videoInfos: [],

      // 视频 vs4 播放
      videoVisible: false,
      vs4Video: {
        loading: false,
        isTrailer: false,
        trailerDuration: 0,
        resourceId: "",
        videoUrl: "",
        coverUrl: "",
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "",
        title: ""
      },
      isFullBox: null,
      pptError: false,
      pdfData: null,
      lastClickTime: null,
      otherParams: { top: 0, left: 0, w: 16, h: 9 }, // ppt离外面元素的偏移量
      tabItemH: 0, // tab的高度
      pptSize: ""
    };
  },
  watch: {
    resourceId: {
      immediate: true,
      handler(val) {
        if(val) {
          SetVideoStatistics({
            resourceId: val,
            level: this.level,
            subject: this.subject,
            type: 'preview'
          });
        }
      }
    },
    /**
     * 监视页面索引，获取视频信息
     */
    pageIndex: {
      deep: true,
      immediate: true,
      handler: function(newValue) {
        if (
          this.videos[`page${this.pageIndex + 1}`] &&
          this.videos[`page${this.pageIndex + 1}`].length
        ) {
          this.videoInfo = {};
          this.videoInfos = this.videos[`page${this.pageIndex + 1}`];
          this.videoInfo = this.videos[`page${this.pageIndex + 1}`][0];
        } else {
          this.videoInfo = {};
          this.videoInfos = [];
        }
      }
    },
    pageCount: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        this._getMiniList(val);
      }
    }
  },
  computed: {
    preDis() {
      return this.pageIndex > 0 ? false : true;
    },
    nextDis() {
      return this.pageIndex < this.pageCount - 1 ? false : true;
    }
  },
  methods: {
    /**
     * pdf加载失败的回调函数
     * **/
    _loadError(val) {
      this.pptError = true;
    },
    _loading(val) {
      if (val) {
        this._getPdf();
      }
    },
    _getPdf() {
      this.pdfData = Pdf.createLoadingTask(this.pdfUrl);
      this.pdfData.then(pdf => {
        // console.log('pdf', pdf);
      });
    },

    /**
     * 缩略图列表
     * **/
    _getMiniList(val) {
      this.pageList = [...this.thumbnails];
    },
    /**
     * 下面缩略图展开折叠
     * **/
    _upDown() {
      this.upDown = !this.upDown;
      // $('#preListWrap').animate({ "height": this.upDown ? (this.imageW > 110 ? 100: 76) : 0 + "px" });
    },
    /**
     * 上一个下一个
     * **/
    _pageChange(flag) {
      // console.log(Pdf);
      if (flag === "left" && !this.preDis) {
        this.pageIndex > 0 && this.pageIndex--;
        this._setPosition("left", 1, true);
      } else if (flag === "right" && !this.nextDis) {
        this.pageIndex < this.pageCount - 1 && this.pageIndex++;
        this._setPosition("right", 1, true);
      }
    },
    /**
     * 下面缩略列表上一页下一页
     * **/
    _miniPageChange(flag) {
      if (flag === "left") {
        this._setPosition("left");
      } else {
        this._setPosition("right");
      }
    },
    /**
     * 下面缩略列表上点击某一个
     * **/
    _miniPageClick(index) {
      let deff = Math.abs(this.pageIndex - index);
      if (this.pageIndex > index) {
        this.pageIndex = index;
        this._setPosition("left", deff, true);
      } else {
        this.pageIndex = index;
        this._setPosition("right", deff, true);
      }
    },

    /**
     * 设置list宽度
     * **/
    _setListWidth() {},

    /**
     * @desc 设置缩略列表位置移动
     * @param type 上left 下right
     * @param num 每次移动的个数 默认5个
     * @param select 点击某一个 默认false
     * **/
    _setPosition(type, num = 5, select = false) {
      let isAnimate = true;
      if (
        this.lastClickTime &&
        new Date().getTime() - this.lastClickTime < 400
      ) {
        // animate的默认动画时间是400毫秒，如果连续点击的时间小于400毫秒，则此次左右滑动就无需动画了
        isAnimate = false;
      }
      this.lastClickTime = new Date().getTime();
      // if (this.switching) { // 上次缩略图的定位还没完成（因为animate是要时间执行的）
      //   return;
      // }
      let wrapW = $("#previewList").width(); // 放缩略图的盒子的宽度
      let pptListUl = $("#pptListUl");
      let allW = pptListUl.width(); // 所有缩略图的宽度
      let allML = parseInt(pptListUl.css("margin-left").replace("px", "")); // 缩略图的margin-left
      if (allW <= wrapW) {
        return;
      } // 如果所有缩略图的宽度还没有放缩略图的盒子宽的话 左右按钮都没用
      if (type === "left") {
        // 点击上一个---margin-left变大
        if (allML >= 0) {
          return;
        } // 如果margin-left大于0的话，说明没有必要再往右去了
        this.switching = true;
        let compute = allML + this.imageW * num; // 计算往右以后margin-left的宽度
        if (compute >= 0) {
          // 如果计算后的margin-left大于0，说明没有必要再往右去了
          compute = 0;
        }
        // 如果点击的是具体的某一个，所有右移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.pageIndex * this.imageW + 20;
          if (Math.abs(compute - wrapW) < l) {
            compute = -l + 20 + this.imageW;
          }
        }

        pptListUl.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {
            this.switching = false;
          }
        );
        return;
      }
      if (type === "right") {
        // 点击下一个---margin-left变小
        if (allW + allML < wrapW) {
          return;
        } // 如果所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
        this.switching = true;
        let compute = allML - this.imageW * num; // 计算往左以后margin-left的宽度
        if (allW + compute < wrapW) {
          // 如果计算后的所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
          compute = -(allW - wrapW);
        }
        // 如果点击的是具体的某一个，所有左移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.pageIndex * this.imageW + 20;
          if (Math.abs(compute) > l || Math.abs(compute + wrapW) > l) {
            compute = -l + 20;
          }
        }
        pptListUl.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {
            this.switching = false;
          }
        );
      }
    },

    /**
     * 展开全屏
     * **/
    _fullScreen() {
      this.$nextTick(() => {
        // 当前不是全屏才通过requestFullScreen开启全屏
        !isFullscreen() && enterFullScreen(this.$refs.pptPreviewWrap);
      });
    },
    /**
     * 键盘事件
     */
    _keydownEvent(ev) {
      if (ev.keyCode === 37 || ev.keyCode === 38) {
        // 上一张
        this._pageChange("left");
      } else if (ev.keyCode == 39 || ev.keyCode === 40) {
        // 下一张
        this._pageChange("right");
      }
    },

    /**
     * resize事件
     */
    _resizeEvent: debounce(function() {
      let fullEle = document.fullscreenElement;
      // 当前不是全屏，才隐藏组件
      if (isFullscreen()) {
        this.isFull = true;
        if (
          this.videoVisible &&
          fullEle.getAttribute("id") == "pptPreviewWrap"
        ) {
          this.videoVisible = false;
          this._vs4Close();
        }
      } else {
        if (
          this.videoVisible &&
          this.isFullBox === "ppt" &&
          !fullEle &&
          this.isFull
        ) {
          this.videoVisible = false;
        } else if (this.videoVisible && !this.isFullBox && this.isFull) {
          this._vs4Close();
        }
        this.isFull = false;
      }
      if (fullEle) {
        const _id = fullEle.getAttribute("id");
        if (_id === "pptPreviewWrap") {
          this.isFullBox = "ppt";
        } else if (_id === "H5Video") {
          this.isFullBox = "H5Video";
        } else {
          this.isFullBox = "video";
        }
      } else {
        this.isFullBox = null;
      }
      this.$nextTick(() => {
        this._resizeForPPTSize();
      });
    }),
    /**
     * 窗口变化对ppt尺寸的影响以及对播放按钮的影响
     * **/
    _resizeForPPTSize() {
      // 设置ppt大小
      let _ch = $(`#${this.boxId}`).height();
      let _cwActual = $(`#${this.boxId}`).width();
      if (
        this.boxId !== "pdfPreviewContent" &&
        this.tabItemH && Math.abs(this.tabItemH - _ch) < 10
      ) {
        this.tabItemH = _ch;
        return;
      }
      this.tabItemH = _ch;
      if (_ch) {
        if (_ch > 800) {
          _ch = _ch - 200;
        } else if (_ch > 700) {
          _ch = _ch - 100;
        } else if (_ch > 420) {
          _ch = _ch - 20;
        }
        let _cw = (_ch * 16) / 9;
        if (_cwActual < _cw || _cwActual - _cw < 60) {
          _cw = _cwActual - 100;
          _ch = (_cw * 9) / 16;
        }
        if (this.boxId === "pdfPreviewContent") {
          $("#pptPreviewId").css({
            width: _cw + "px",
            height: _ch + "px"
          });
        } else {
          $("#pptPreviewId").css({
            width: _cw + "px",
            height: _ch + "px",
            marginTop: -(_ch / 2) + "px",
            marginLeft: -(_cw / 2) + "px"
          });
        }
        if (_ch <= 420) {
          this.pptSize = "h-420";
          this.imageW = 110;
        } else {
          this.pptSize = "";
          this.imageW = 143;
        }
      }

      // 设置ppt中播放按钮的大小
      // if(this.videoInfos && this.videoInfos.length) {
      let _pptSize = this.resolution.split("*");
      let _fullH = $("#pptPreviewWrap").height();
      let _setW = (_pptSize[0] * _fullH) / _pptSize[1];
      $("#pptPreviewContent").height(_fullH);
      $("#pptPreviewContent").width(_setW);
      setTimeout(() => {
        let _dom = $("#pptPreviewContent");
        let w = _dom.width();
        let h = _dom.height();
        let posT = _dom.css("marginTop");
        let posL = _dom.css("marginLeft");
        posT = parseFloat(posT);
        posL = parseFloat(posL);
        let _pptSize = this.resolution.split("*");
        this.otherParams = {
          top: posT,
          left: posL,
          w: w,
          h: h,
          w_actual: parseFloat(_pptSize[0]),
          h_actual: parseFloat(_pptSize[1])
        };
      }, 200);
      // }

      // 设置ppt下面预览缩略图
      if (!this.isFull) {
        setTimeout(() => {
          let w = this.pageList.length * this.imageW;
          $("#pptListUl").css("width", w + "px");
        }, 500);
      }
    },

    /**
     * 可点击区域的点击事件
     */
    _areaButtonClick(item) {
      if(!item.i) {
        return;
      }
      if (this.videoVisible) {
        this.$refs.videoDragRef._vs4Close("switch");
        this.videoVisible = false;
      }

      // this.videoInfo = item;
      let _videoUrl =
        item.i.toString().indexOf("http") === 0
          ? item.i
          : `/teacher/resourceAuthentication/${item.i}`;
      let _title = "视频";
      if (item.a && item.a.indexOf("group1/") === -1) {
        _title = item.a;
      }
      if (this.isFull) {
        this.videoVisible = true;
        this.vs4Video = {
          loading: false,
          isTrailer: false,
          trailerDuration: 0,
          resourceId: "",
          videoUrl: _videoUrl,
          coverUrl: item.c,
          enValue: "",
          zhValue: "",
          enAndzhValue: "",
          tValue: "bearer " + Cookies.get("mvr_student_Token"),
          title: _title,
          hadLogo: item.hadLogo,
          level: item.level ? item.level : (item.levelId ? item.levelId: 2),
          subject: item.subject ? item.subject : (item.subjectId ? item.subjectId : 0)
        };
        return;
      }
      this.videoVisible = true;
      this.vs4Video.loading = true;
      // setTimeout(() => {
      this.vs4Video.loading = false;
      this.vs4Video = {
        loading: false,
        isTrailer: false,
        trailerDuration: 0,
        resourceId: "",
        videoUrl: _videoUrl,
        coverUrl: item.c,
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "bearer " + Cookies.get("mvr_student_Token"),
        title: _title,
        hadLogo: item.hadLogo,
        level: item.level ? item.level : (item.levelId ? item.levelId: 2),
        subject: item.subject ? item.subject : (item.subjectId ? item.subjectId : 0)
      };
        // }, 1000);
    },
    /**
     * vs4关闭预览
     * **/
    _vs4Close() {
      this.vs4Video = {
        loading: false,
        isTrailer: false,
        trailerDuration: 0,
        resourceId: "",
        videoUrl: "",
        coverUrl: "",
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "",
        title: ""
      };
      this.videoVisible = false;
    },

    handleScroll: debounce(function(e) {
      var direction = e.deltaY > 0 ? "down" : "up";
      this._pageChange(e.deltaY > 0 ? "right" : "left");
    }, 50)
  },
  mounted() {
    this.$nextTick(() => {
      this._resizeForPPTSize();
    });
    // !this.fixedSize && window.addEventListener("resize", this._resizeEvent);
    window.addEventListener("resize", this._resizeEvent);
  },
  created() {
    window.addEventListener("keydown", this._keydownEvent);
  },
  destroyed() {
    this._vs4Close();
    window.removeEventListener("keydown", this._keydownEvent);
    // !this.fixedSize && window.removeEventListener("resize", this._resizeEvent);
    window.removeEventListener("resize", this._resizeEvent);
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.ppt-preview {
  height: 557px;
  width: 990px;
  margin: 0 auto;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden;

  .opacity0 {
    opacity: 0;
  }

  .ppt-wrap {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    background: #FFFFFF;

    .pdf-content {
      height: 100%;
      max-width: 100%;
      margin: 0 auto;
      overflow: hidden;
    }

    .pre-btn, .next-btn {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #C0E9D9;
      z-index: 10;

      &:hover {
        background: #cef1e3;
      }

      i.iconfont {
        font-size: 24px;
        color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .pre-btn {
      left: 10px;
    }

    .next-btn {
      right: 10px;
    }

    .btn-dis {
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.2);

      i.iconfont {
        color: #A3A3A3;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }

    .pre-list-wrap {
      height: 100px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      transition: height 0.3s linear;
      z-index: 10;

      .up-down {
        width: 50px;
        height: 20px;
        line-height: 20px;
        position: absolute;
        top: -20px;
        left: 50%;
        margin-left: -25px;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 10px 10px 0px 0px;
        cursor: pointer;

        i.iconfont {
          margin-left: 18px;
          font-size: 14px;
        }
      }

      .current-page {
        float: left;
        color: #ffffff;
        font-size: 18px;
        max-width: 80px;
        height: 100px;
        line-height: 100px;
        padding: 0 10px;
        overflow: hidden;
      }

      .mini-list-box {
        float: right;
        width: calc(100% - 100px);
        height: 100%;
        padding: 0 20px;
        margin-right: 20px;
        position: relative;

        .mini-pre-btn, .mini-next-btn {
          height: 72px;
          width: 18px;
          color: #ccc;
          background: rgba(121, 121, 121, 0.3);
          cursor: pointer;
          position: absolute;
          top: 14px;
          z-index: 10;
          border-radius: 5px;

          &:hover {
            background: rgba(121, 121, 121, 0.6);
          }

          i.iconfont {
            font-size: 16px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #FFFFFF;

            &:hover {
              opacity: 0.8;
            }
          }
        }

        .mini-pre-btn {
          left: 0;
        }

        .mini-next-btn {
          right: 0;
        }

        .mini-wrap-box {
          width: calc(100% - 20px);
          margin: 0 10px;
          padding: 0 10px;
          height: 100%;
          overflow: hidden;

          .list-ul {
            height: 90px;
            margin-top: 15px;
            margin-left: 0;
            width: 999999px;

            .list-li {
              float: left;
              width: 128px;
              height: 72px;
              margin-right: 15px;
              cursor: pointer;
              border: 2px solid transparent;
              border-radius: 5px;
              background-color: #f5eded;
              overflow: hidden;
              position: relative;

              img {
                max-height: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }

              .pdf-thumbnail {
                width: 100%;
                height: 100%;
                cursor: pointer;

                div {
                  -moz-user-select: none; /* 火狐 */
                  -webkit-user-select: none; /* webkit浏览器 */
                  -ms-user-select: none; /* IE10 */
                  -khtml-user-select: none; /* 早期浏览器 */
                  user-select: none;
                  cursor: pointer;
                }
              }
            }

            .select-page {
              border: 2px solid #75C73B !important;
              transform: scale(1.1);
            }
          }
        }
      }
    }
  }

  .up-down-change {
    height: 0 !important;
    transition: height 0.3s linear !important;
  }

  #pptPreviewWrap.h-420 {
    .pre-btn, .next-btn {
      width: 34px;
      height: 34px;

      i.iconfont {
        font-size: 18px;
      }
    }

    .pre-list-wrap {
      height: 76px;

      .current-page {
        height: 76px;
        line-height: 76px;
        font-size: 16px;
      }

      .mini-list-box {
        width: calc(100% - 94px);
        margin-right: 15px;

        .mini-pre-btn, .mini-next-btn {
          height: 50px;
          width: 16px;

          i.iconfont {
            font-size: 14px;
          }
        }

        #previewList {
          width: calc(100% - 10px);
          margin: 0px 5px;

          #pptListUl {
            height: 60px;
            margin-top: 10px;

            .list-li {
              width: 100px;
              height: 56px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .ppt-bottom-btn {
    height: 60px;
    line-height: 60px;

    .ivu-btn {
      margin: 0 10px;
    }
  }

  .ppt-error {
    width: 100%;
    height: 100%;
    position: relative;

    p {
      width: 100%;
      font-size: 30px;
      color: #7c7c7c;
      font-weight: bold;
      text-align: center;
      position: absolute;
      top: 50%;
      margin-top: -15px;
    }
  }
}
</style>
